// apps/website/src/layouts/PublicPagesLayout.tsx

import  { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { AppHeader, Footer } from '@dopomogai/components';

import { useSharedLayoutData } from '../hooks/useSharedLayoutData';
import { LoadingSpinner } from '../components/LoadingSpinner';
import type { OutletContextType } from '../routes/outlet-context';
import ChatWidget from '../chat/ChatWidget';

export function PublicPagesLayout() {
  const { isLoading, headerDataWithAuth, footerDataAdapted, handleAction } = useSharedLayoutData({
    isPublicSite: true,
  });
  const headerWrapRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = headerWrapRef.current;
    if (!el) return;

    const setVar = () => {
      const h = Math.round(el.getBoundingClientRect().height || 80);
      document.documentElement.style.setProperty('--site-header-h', `${h}px`);
    };

    setVar();
    const ro = new ResizeObserver(setVar);
    ro.observe(el);
    window.addEventListener('resize', setVar);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', setVar);
    };
  }, []);

  if (isLoading) {
    return (
      <div className="flex flex-col min-h-screen bg-slate-50">
        <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-md h-20 border-b-2 border-black/10" />
        <main className="flex-grow flex items-center justify-center">
          <LoadingSpinner message="Loading site..." />
        </main>
        <footer className="bg-gray-900 border-t min-h-[20rem] z-1000" />
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-slate-50">
      <div ref={headerWrapRef} className="sticky top-0 z-40">
        <AppHeader onAction={handleAction} data={headerDataWithAuth as any} />
      </div>
      <main className="flex-grow">
        <Outlet context={{ onAction: handleAction } satisfies OutletContextType} />
      </main>
      <div className="relative z-20"> <Footer onAction={handleAction} data={footerDataAdapted as any} /> </div>
      <ChatWidget />
    </div>
  );
}

export default PublicPagesLayout;
